// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.86.1-next',
  revision: '6dd6461a8',
  branch: 'next',
  date: 'Tue, 10 Mar 2026 09:23:36 GMT'
};